import {Component, ContentChild, ElementRef, EventEmitter, Input, Output, TemplateRef, ViewEncapsulation} from '@angular/core';
import {IdName} from '../../models/id-name.model';
import {SelectItem} from 'primeng/api';
import {HttpClient} from '@angular/common/http';

@Component({
  selector: 'si-selector-custom',
  templateUrl: './selector-custom.component.html',
  styleUrls: ['./selector-custom.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SelectorCustomComponent {
  @Input() id: string;
  @Input() name: string;
  @Input() text: string;
  @Input() styleClass: string;
  @Input() styleClassSelector: string;
  @Input() disabled: boolean;
  @Input() selectDefault: boolean;
  @Input() showHighlight = false;
  @Input() hideOnEmpty = false;
  @Input() hideSelectorCustom = false;
  @Input() useButtonOneItem = false;
  @Input() openTop = false;
  @Output() modelChange = new EventEmitter<IdName>();
  @Output() onOptionsLoaded = new EventEmitter<number>();
  @ContentChild('selectedItemCustom', {static: true}) selectedItemCustom: TemplateRef<ElementRef>;
  @ContentChild('itemCustom', {static: true}) itemCustom: TemplateRef<ElementRef>;
  model: IdName;
  private _path: string;
  private _values: IdName[];

  constructor(
    private http: HttpClient
  ) {
  }

  get path(): string {
    return this._path;
  }

  @Input()
  set path(val: string) {
    this._path = val;
    if (val) {
      this.getValues();
    }
  }

  get values(): IdName[] {
    return this._values;
  }

  @Input()
  set values(val: IdName[]) {
    this._values = val;
    if (val) {
      this.setDefaultOption();
    }
  }

  async getValues(): Promise<void> {
    const response = await this.http.get(this.path).toPromise();
    this.values = response as IdName[];
    this.onLoadedOptions();
    this.setDefaultOption();
  }

  onLoadedOptions(): void {
    this.onOptionsLoaded.emit(this.values?.length);
  }

  setDefaultOption(): void {
    if (!this.values?.length) {
      return;
    }

    if (this.selectDefault) {
      const defaultOption = this.values.find((option) => option.isDefault);
      this.model = defaultOption || this.values[0];
      this.modelChange.emit(this.model);
    } else {
      this.model = this.values[0];
    }
  }

  onSelectItem(item: SelectItem): void {
    this.modelChange.emit(item?.value);
  }

  onClickItem(value: IdName): void {
    this.modelChange.emit(value);
  }
}
